<template>
<div>
  <form>
    <div class="columns">
      <div class="column">
        <text-input
          :value="standard.name"
          @input="updateName"
          :error="$root.errorBag.name">
          Name
        </text-input>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <markdown-editor 
          :value="standard.description"
          @input="updateDescription"
          :error="$root.errorBag.description">
          Description
        </markdown-editor>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <submit-button @submit="storeStandard" left-icon="save">Store</submit-button>
      </div>
    </div>
  </form>
</div>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false
  }),
  
  methods: {
    ...mapMutations('standard', [
      'updateName',
      'updateDescription'
    ]),
    storeStandard() {
      this.working = true
      this.$store.dispatch('standard/store').then(() => {
        this.working = false
        this.$router.push({
          name: 'standards'
        })
      }).catch(error => {
        this.working = false
      })
    }
  },

  computed: {
    ...mapGetters('standard', [
      'standard'
    ])
  }

}
</script>